import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback } from 'react';
import { Add } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { send_z3k_command } from 'z3k-settings/redux/actions';
import { useAction } from 'shared/hooks/redux/hooks';
const RadioRegistrationButton = memo(function RadioRegistrationButton(props) {
    const { device_id, module_id, module_state } = props;
    const sendZ3kCommand = useAction(send_z3k_command);
    const onStartRegistration = useCallback(() => sendZ3kCommand(device_id, module_id, 'AddRadiosensors', { prevModuleId: null }, null, false), [device_id, module_id, sendZ3kCommand]);
    return (_jsx(LoadingButton, { loading: module_state?.add_enable, onClick: onStartRegistration, size: "small", color: "primary", variant: "contained", startIcon: _jsx(Add, {}), children: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F" }));
});
export { RadioRegistrationButton };
